import moment from "moment";
import { AppointmentService } from "../../core/http/service/AppointmentService";
import { SchedulingService } from "../../core/http/service/SchedulingService";
import BaseResponse from "../../models/core/BaseResponse";

export const FETCH_APPOINTMENTS = "FETCH_APPOINTMENTS";
export const FETCH_ATENDIMENTOS_PACIENTE = "FETCH_ATENDIMENTOS_PACIENTE";
export const FETCH_ATENDIMENTOS_STATUS_IMPRESSAO = "FETCH_ATENDIMENTOS_STATUS_IMPRESSAO";
export const FETCH_PRONTUARIO_LIST = "FETCH_PRONTUARIO_LIST";
export const FETCH_PRONTUARIO_LIMPAR = "FETCH_PRONTUARIO_LIMPAR"
export const FETCH_ATENDIMENTO_STATUS_SALVAR = "FETCH_ATENDIMENTO_STATUS_SALVAR"

const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

export const fetchAppointments = (
  unidadeId: string,
  data: string,
  nome: string,
  tiposConsulta: string[],
  statusPresenca: string,
  inativo: boolean
) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    try {
      const params = {
        unidadeAtendimentoId: unidadeId,
        data,
        nome: nome !== "" ? nome : null,
        tiposConsulta: tiposConsulta.length !== 0 ? tiposConsulta : null,
        statusPresenca: statusPresenca !== "" ? statusPresenca : null,
        inativo: inativo
      };
      const appointments: any[] = [];
      const response: any = await service.getPanelInfo(params);
      const baseResponse: any = new BaseResponse().fromJSON({
        ...response.data,
      });
      baseResponse.data.forEach((d: any) => {
        appointments.push(d);
      });

      dispatch({
        type: FETCH_APPOINTMENTS,
        appointments: appointments,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const fetchAppointmentsByPacienteId = (
  pacienteId: string,
  anoFilter: string | null = ""
) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    try {
      const params = {
        PacienteId: pacienteId,
        PageSize: 5000,
      };
      const appointments: any[] = [];

      const response: any = await service.getAtendimentoList(params);
      const baseResponse: any = new BaseResponse().fromJSON({
        ...response.data,
      });
      baseResponse.data.forEach((d: any) => {
        appointments.push(d);
      });
      const atendimentosAbertos = appointments.filter(
        ap =>
          !ap.finalizado &&
          (anoFilter === "Todos"
            ? true
            : moment(ap.horario).format("YYYY") === anoFilter)
      );
      const atendimentosAbertosOrdenados = atendimentosAbertos.sort((a, b) =>
        moment(a.horario) > moment(b.horario) ? 1 : -1
      );
      const atendimentosFinalizados = appointments.filter(
        ap =>
          ap.finalizado &&
          (anoFilter === "Todos"
            ? true
            : moment(ap.horario).format("YYYY") === anoFilter)
      );
      const atendimentosFinaliazdosOrdenados = atendimentosFinalizados.sort(
        (a, b) => (moment(a.horario) > moment(b.horario) ? -1 : 1)
      );

      dispatch({
        type: FETCH_ATENDIMENTOS_PACIENTE,
        atendimentosEmAberto: atendimentosAbertosOrdenados,
        atendimentos: atendimentosFinaliazdosOrdenados,
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const fetchAppointmentOpenByPacienteId = (pacienteId: string) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    try {
      const params = {
        PacienteId: pacienteId,
        PageSize: 5000,
      };
      const appointments: any[] = [];

      const response: any = await service.getAtendimentoList(params);
      const baseResponse: any = new BaseResponse().fromJSON({
        ...response.data,
      });
      baseResponse.data.forEach((d: any) => {
        appointments.push(d);
      });
      const atendimentosAbertos = appointments.filter(ap => !ap.finalizado);
      const atendimentosAbertosOrdenados = atendimentosAbertos.sort((a, b) =>
        moment(a.horario) > moment(b.horario) ? 1 : -1
      );

      return atendimentosAbertosOrdenados;
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const performEncaixe = (
  pacienteId: string,
  empresaId: string,
  tipoConsulta: string,
  unidadeAtendimentoId: string,
  profissionalId: string,
  horario: string
) => {
  const service: SchedulingService<any> = new SchedulingService();
  return async (dispatch: any) => {
    try {
      const params = {
        pacienteId,
        empresaId,
        tipoConsulta,
        unidadeAtendimentoId,
        profissionalId,
        horario,
      };

      await service.postEncaixe(params);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const updateAttendanceStatus = (
  agendamentoId: string,
  statusPresenca: string
) => {
  const service: SchedulingService<any> = new SchedulingService();
  return async (dispatch: any) => {
    try {
      const params = {
        statusPresenca,
      };

      await service.updateAttendanceStatus(agendamentoId, params);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const registerAppointment = (
  object: any,
  isSalvar: boolean,
  atendimentoId: string
) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    dispatch({
      type: FETCH_ATENDIMENTO_STATUS_SALVAR,
      statusSalvar: "",
      appointmentId: "",
    });
    try {
      if (atendimentoId === "") {
        const response: any = await service.registerAppointment({ ...object, finalizado: !isSalvar });
        if (response.status == 200){
          dispatch({
            type: FETCH_ATENDIMENTO_STATUS_SALVAR,
            statusSalvar: "NOVO",
            appointmentId: response.data.data.id
          });
        }
      } else {
        const response: any = await service.updateAppointment(
          { ...object, finalizado: !isSalvar, id: atendimentoId },
          atendimentoId
        );
        if (response.status == 200){
          dispatch({
            type: FETCH_ATENDIMENTO_STATUS_SALVAR,
            statusSalvar: "S",
            appointmentId: response.data.data.id
          });
        }
      }
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const deleteAppointment = (id: string) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    try {
      await service.deleteAtendimentoById(id);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const fetchImprimiveis = async () => {
  const service: AppointmentService = new AppointmentService();
  try {
    const impremiveis: any[] = [];
    const response = await service.getImprimiveis();

    const dados: any = response.data;

    dados.data.forEach((d: any) => {
      impremiveis.push(d);
    });

    return impremiveis;
  } catch (error: any) {
    sendToAnalytics(error);
    throw error;
  }
};

export const getPdfs = (id: string, list: any) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    try {
      dispatch({
        type: FETCH_ATENDIMENTOS_STATUS_IMPRESSAO,
        statusImpressao: ""
      });
      const imprimiveis = [...list];

      const response: any = await service.getGeneratePdfs({ imprimiveis }, id);
      
      const data = response.data;
      if (data.size > 0){
        const file = new Blob([data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        dispatch({
          type: FETCH_ATENDIMENTOS_STATUS_IMPRESSAO,
          statusImpressao: "S"
        });
      }
      else{
        dispatch({
          type: FETCH_ATENDIMENTOS_STATUS_IMPRESSAO,
          statusImpressao: "N"
        });
      }
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};


export const limparGerarImpressao = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: FETCH_ATENDIMENTOS_STATUS_IMPRESSAO,
        statusImpressao: ""
      });
  
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const fetchProntuario = (
  unidade: any,
  nome: string
) => {
  const service: AppointmentService = new AppointmentService();
  return async (dispatch: any) => {
    try {

      const params = {
        "pageSize": 500, 
        "unidadeId": `${unidade.id}`,
        "nome": nome 
      };

      const prontuarios: any[] = [];
      const response: any = await service.getPronturariosList(params);
      const baseResponse: any = new BaseResponse().fromJSON({
        ...response.data,
      });
      baseResponse.data.forEach((d: any) => {
        prontuarios.push(d);
      });

      dispatch({
        type: FETCH_PRONTUARIO_LIST,
        prontuarios: prontuarios,
      });

    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const fetchProntuarioLimpar = () => {
  return (dispatch: any) => {
    dispatch({
      type: FETCH_PRONTUARIO_LIMPAR,
      prontuarios: [],
    });
  };
};